import { ReactNode } from "react"
import cx from "classnames"

export interface OrderedListProps {
  list: ReactNode[]
  centered?: boolean
  className?: string
  itemClass?: string
}

const OrderedList = ({
  list,
  centered = false,
  className,
  itemClass,
}: OrderedListProps) => {
  if (list === null || list === undefined || list?.length === 0) {
    return null
  }

  return (
    <ol className={cx("list-none pl-9", className)}>
      {list.map((item, i) => (
        <li
          key={i}
          className={cx(
            "relative leading-[130%] tracking-[0.32px] mb-6",
            itemClass
          )}
        >
          <span
            className={cx(
              "absolute w-6 h-6 flex items-center justify-center text-leaf text-base leading-[1.50] tracking-[0.02em] rounded-full border border-leaf left-[-36px]",
              {
                "top-1/2 -translate-y-1/2": centered,
                "top-0": !centered,
              }
            )}
          >
            {i + 1}
          </span>

          {item}
        </li>
      ))}
    </ol>
  )
}

export default OrderedList
